import React, { useEffect, useState } from 'react'
import AutoComplete from '@commonComponents/formComponents/AutoComplete'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import PopUpIcon from '@commonComponents/formComponents/PopUpIcon'
import { getArtNumByHTSCode } from '../../../../NL_App/api/getNLForm'
import { CustomLoader } from '@commonComponents/formComponents/loader'


const ECCNNumber = ({ translate, commodityCode, ...rest }) => {
    const { isDisabled } = useCurrentShipmentType()
    const [list, setList] = useState([])
    const [isLoading, setLoader] = useState(false)

    const onSearchChange = async (value) => {
        setLoader(true)
        const response = await getArtNumByHTSCode(commodityCode)
        const list = response?.data?.eventMessage?.dualUseCode?.map((item) => ({id:item, value: item})) || []
        setList(list)
        setLoader(false)
    }
    useEffect(() => { setList([]) }, [commodityCode])

    return (
        <>
            <AutoComplete
                minCharacters={1}
                disabled={isDisabled || !commodityCode}
                labelIcon={<PopUpIcon icon='info circle' popupText={translate('Enter at least 1 digit')} />}
                {...rest}
                renderItem={({ value, text, id }) => {
                    return (
                        <span key={id} style={{ fontWeight: 'bold' }} className='text'>
                            {`${value} ${text ? `- ${text}` : ""}`}
                        </span>
                    )
                }}
                dataSource={list}
                onSearchChange={onSearchChange}
            />
            {isLoading && <CustomLoader/>}
        </>
    )
}

export default ECCNNumber